__turbopack_context__.v({
  "paginator": "Pagination-module__kzXGfq__paginator",
  "perPage": "Pagination-module__kzXGfq__perPage",
});
